// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M12.32 5.42L13.54 4.2C14.15 3.58 14.15 2.58 13.54 1.96C12.92 1.35 11.92 1.35 11.3 1.96L10.08 3.18L3.23 10.04C2.89 10.38 2.64 10.8 2.52 11.26L2.01 13.15C1.95 13.36 2.14 13.55 2.35 13.49L4.24 12.98C4.7 12.86 5.12 12.61 5.46 12.27L12.32 5.42ZM10.08 3.18L10.35 3.78C10.63 4.39 11.11 4.87 11.72 5.15L12.32 5.42M8.11 12.92C11.11 14.97 11.31 10.69 14 12.92',
];
